import React from "react"
import { UncontrolledTooltip, Card } from "reactstrap"
import gql from "graphql-tag"

import DatetimeRenderer from "../../Material/DatetimeRenderer"
import UpdateIncidentDocumentInfo from "../Components/UpdateIncidentDocumentInfo"
import toTitleCase from "../../Functions/toTitleCase"
import { cleanDocumentUrl, isImage } from "../../Material/DocumentModal/DocumentsListNew"
import DocumentHistoryPopover from "../../Material/DocumentModal/DocumentHistoryPopover"
import ConfirmationPopup from "../../Material/ConfirmationPopup"
import withApolloClient from "../../withApolloClient"
import "./DocumentsTab.css"

const UPDATE_INCIDENT_DOCUMENT = gql`
  mutation updateIncidentDocument($input: UpdateIncidentDocumentMutationInput!) {
    updateIncidentDocument(input: $input) {
      ok
      errors {
        field
        messages
      }
    }
  }
`

class DocumentDetails extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            error: null,
            loading: false,
            documentArchived: false,
        }
    }
    isVideo(url, document) {
        if (!url && !document) return false
        const videoExts = ['.mp4', '.mov']
        const lowerUrl = (url || '').toLowerCase()
        const lowerDoc = (document || '').toLowerCase()
        return videoExts.some(ext => lowerUrl.endsWith(ext) || lowerDoc.endsWith(ext))
    }

    handleArchiveUnarchiveDocument = (id, isArchived) => {
        this.setState({ loading: true, error: null })
        try {
            this.props.apolloClient.mutate({
                mutation: UPDATE_INCIDENT_DOCUMENT,
                variables: { input: { incidentDocumentId: id, isArchived: isArchived } },
            }).then((result) => {
                if (result.data?.updateIncidentDocument?.ok) {
                    this.setState({ documentArchived: true, error: null, loading: false })
                    this.props.refetchQuery && this.props.refetchQuery()
                } else {
                    this.setState({ loading: false, documentArchived: false, error: result.data.updateIncidentDocument?.errors[0]?.messages[0] })
                }
            }).catch((error) => {
                let errorMessage = "An error has occurred: " + error.message
                this.setState({ error: errorMessage, loading: false, documentArchived: false, })
            })
        } catch (err) {
            this.setState({ error: err.message, loading: false })
        }
    }

    render() {
        const { document, idx, refetchQuery } = this.props
        return (
            <Card className="DocumentCard" key={idx}>
                <div className="DocumentCardHeader">
                    <p className="DocumentCardTitle">
                        <span>
                            <i
                                className={
                                    document.document &&
                                        document.document.toUpperCase().slice(-4) === ".PDF"
                                        ? "fa fa-file-pdf-o"
                                        : "fa fa-picture-o"
                                }
                                aria-hidden="true"
                            ></i>
                        </span>&nbsp;&nbsp;
                        <span style={{ color: "black" }}>{document.documentType ? toTitleCase(document.documentType.typeName) : "--"}</span>
                    </p>
                    <p>
                        {isImage(cleanDocumentUrl(document.url), document.document) &&
                            <>
                                <input
                                    type="checkbox"
                                    className="doc-select-checkbox"
                                    checked={this.props.isSelected}
                                    onChange={() => this.props.toggleSelectDoc(document)}
                                />
                                &nbsp;&nbsp;
                            </>
                        }
                        <i className="fa fa-arrows-alt" id={`view_full_document_${idx}`}
                            onClick={() => this.props.viewDocuments()}
                        />
                        <UncontrolledTooltip placement="top" target={`view_full_document_${idx}`}>View Full Document</UncontrolledTooltip>
                    </p>
                </div>
                <div className="DocumentCardPreview">
                    {document ? (
                        this.isVideo(document.url, document.document) ?
                            <video className="DocumentCardPreviewEmbed DocViewerVideo" src={document.url} controls style={{ maxWidth: '100%', maxHeight: 180 }} /> :
                            isImage(document.url, document.document) ?
                                <img className="DocumentCardPreviewEmbed DocViewerImage" src={document.url} alt="Document" /> :
                                <iframe scrolling="no" className="DocumentCardPreviewEmbed" src={document.url} title={`document-iframe-${idx}`} />
                    ) : ''}
                </div>
                <div className="DocumentCardFooter">
                    <p className="mb-0" style={{ color: "black", fontWeight: 300 }}>
                        Uploaded At {document.dateAdded ? (
                            <DatetimeRenderer datetime={document.dateAdded} />
                        ) : "--"} {" "}
                        By {document.createdBy?.username || "--"}
                    </p>
                    <p className="mb-0" style={{ color: "black", fontWeight: 300 }}>
                        <>
                            <i
                                className={document.isArchived ? "fa fa-undo text-success" : "fa fa-trash text-danger"}
                                aria-hidden="true"
                                id={`archive_${idx}`}
                                onClick={() => this.setState({ openModal: `archive_document_${idx}` })}
                            />
                            <UncontrolledTooltip placement="top" target={`archive_${idx}`}>
                                {document.isArchived ? "Un-archive Document" : "Archive Document"}
                            </UncontrolledTooltip>
                            {this.state.openModal === `archive_document_${idx}` && (
                                <ConfirmationPopup
                                    open={true}
                                    message={"Are you sure you want to " + (document.isArchived ? "unarchive" : "archive") + " this document?"}
                                    loading={this.state.loading}
                                    handleClose={() => this.setState({ openModal: "" })}
                                    action={"Yes"}
                                    confirmAction={() => this.handleArchiveUnarchiveDocument(document.id, !document.isArchived)}
                                    color={document.isArchived ? "success" : "danger"}
                                    error={this.state.error ? this.state.error : ""}
                                    success={this.state.documentArchived ? "Document " + (document.isArchived ? "Unarchived" : "Archived") + " Successfully" : ""}
                                />
                            )}
                            &nbsp; | &nbsp;
                            <i
                                className="fa fa-history"
                                aria-hidden="true"
                                id={`history_${idx}`}
                                onClick={() => this.setState({ openModal: `history_${idx}` })}
                            />
                            <DocumentHistoryPopover
                                isOpen={this.state.openModal === `history_${idx}`}
                                target={`history_${idx}`}
                                doc={document}
                                handleClosePopover={() => this.setState({ openModal: "" })}
                            />
                            <UncontrolledTooltip placement="top" target={`history_${idx}`}>
                                History
                            </UncontrolledTooltip>
                            &nbsp; | &nbsp;
                            <i
                                className="fa fa-pencil-square-o cursor-pointer"
                                id={`edit_document_notes_${idx}`}
                                aria-hidden="true"
                                onClick={() => this.setState({ openModal: `edit_document_notes_${idx}` })}
                            />
                            &nbsp; | &nbsp;
                            <span id={`docNotesTooltip_${idx}`}>
                                {document.notes
                                    ? document.notes.split(" ").length > 6
                                        ? document.notes.split(" ").slice(0, 6).join(" ") + "..."
                                        : document.notes
                                    : "---"}
                            </span>
                            <UncontrolledTooltip placement="top" target={`docNotesTooltip_${idx}`}>
                                {document.notes}
                            </UncontrolledTooltip>
                        </>
                        {this.state.openModal === `edit_document_notes_${idx}` && (
                            <UpdateIncidentDocumentInfo
                                open={true}
                                target={`edit_document_notes_${idx}`}
                                handleClose={() => this.setState({ openModal: "" })}
                                name={"notes"}
                                value={document.notes || ""}
                                title={"Edit Document Notes"}
                                type="textarea"
                                docId={document.id}
                                refetch={refetchQuery}
                            />
                        )}
                    </p>
                </div>
            </Card>
        )
    }
}

export default withApolloClient(DocumentDetails)